import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { useTranslation } from 'react-i18next';

const EASE: [number, number, number, number] = [0.16, 1, 0.3, 1];

const Hero: React.FC = () => {
    const { t } = useTranslation();
    const reduce = useReducedMotion();

    // Entry motion only. Content is fully visible when reduced motion is on.
    const enter = (delay: number) =>
        reduce
            ? {}
            : {
                  initial: { opacity: 0, y: 18 },
                  animate: { opacity: 1, y: 0 },
                  transition: { delay, duration: 0.7, ease: EASE },
              };

    return (
        <section className="relative overflow-hidden pb-10 pt-24 md:pb-12 md:pt-24">
            {/* Static light wash. Replaces the old looping purple/blue blobs. */}
            <div aria-hidden="true" className="pointer-events-none absolute inset-x-0 top-0 h-[520px]">
                <div className="absolute left-1/2 top-[-240px] h-[560px] w-[560px] -translate-x-1/2 rounded-full bg-blue-500/[0.09] blur-[110px] dark:bg-blue-500/[0.14]" />
                <div className="absolute left-1/2 top-[40px] h-[280px] w-[760px] -translate-x-1/2 rounded-full bg-white/70 blur-[90px] dark:bg-white/[0.03]" />
            </div>

            <div className="relative mx-auto max-w-4xl px-6 text-center">
                <motion.h1
                    {...enter(0)}
                    className="text-[2.25rem] font-bold leading-[1.1] tracking-[-0.02em] text-gray-900 sm:text-5xl md:text-[3.5rem] lg:text-[3.75rem] dark:text-white"
                >
                    {t('hero.title_start')}
                    <br />
                    <span className="text-blue-600 dark:text-blue-400">{t('hero.title_end')}</span>
                </motion.h1>

                <motion.p
                    {...enter(0.08)}
                    className="mx-auto mt-5 max-w-xl text-[14px] leading-[1.75] text-gray-500 [text-wrap:balance] md:text-[15px] dark:text-gray-400"
                >
                    {t('hero.subtitle')}
                </motion.p>
            </div>
        </section>
    );
};

export default Hero;
